<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 md6 offset-md3>
        <v-card>
          <v-card-text>
            <p @click="postStatus = true" class="post-caption" v-if="!postStatus">Post an inquiry...</p>
            <v-layout row wrap v-else>
              <v-flex xs12>
                <v-text-field
                autofocus
                  label="Post an inquiry.."
                  v-model="text"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-layout row>
                  <v-spacer></v-spacer>
                  <v-btn @click="postStatus = false" flat color="red">Cancel</v-btn>
                  <v-btn dark color="green" @click="postAnnouncement">Post</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return {
      postStatus: false,
      text: '',
      loading: false
    }
  },
  methods: {
    async postAnnouncement(){
      try{
        this.loading = true
        await axios.post('/api/class/post', {
          class_code: this.$route.params.id,
          post_content: this.text
        }, { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` }})
        this.$store.dispatch('student/FETCH_POSTS', {class_id: this.$route.params.id})
        this.restart()
      }catch(e){
        this.loading = false
        console.log(e)
      }
    },
    restart(){
      this.loading = false
      this.postStatus = false
      this.text = ''
    }
  }
}
</script>

<style scoped>
.post-caption:hover{
  text-decoration: underline;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Student/Classroom/AddPost.vue